class ClidUIModel {
  constructor({
    companyCode = undefined,
    companyNumber = undefined,
    applyCorporateBenefit = undefined,
    message = undefined,
    b2BCompanyBrand = undefined,
    b2BGenericMessage = undefined,
    b2BMessage = undefined,
    b2bCompanyName =  undefined,
  } = {}) {
    this.companyCode = companyCode;
    this.companyNumber = companyNumber;
    this.applyCorporateBenefit = applyCorporateBenefit;
    this.message = message;
    this.b2BCompanyBrand = b2BCompanyBrand;
    this.b2BGenericMessage = b2BGenericMessage;
    this.b2BMessage = b2BMessage;
    this.b2bCompanyName = b2bCompanyName;
  }
}

export default ClidUIModel;